import styled from "styled-components";
import check from '../../../../assets/addStockModal/pages/check.svg'
import cross from '../../../../assets/addStockModal/pages/cross.svg'
export const Table = styled.table`
  overflow-x: scroll;
  text-align: start;
  border-collapse: collapse;
  width: 90w;
  padding-right: 4vw;
  padding-left: 4vw;

  tr:nth-child(2) td:first-child {
    border-top-left-radius: 0.7vw;
  }

  tr:nth-child(2) td:last-child {
    border-top-right-radius: 0.7vw;
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: 0.7vw;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 0.7vw;
  }
`

export const HeaderRow = styled.tr`
  position: sticky;
  top: 0;
  height: 5vh;
`

export const ItemRow = styled.tr`
  height: 10vh;
  background-color:#fff;

  &:hover{
    background-color:#F7F7F7;
    
    .edit-div{
      visibility:visible;
    }
  }
`
export const OptionsImage = styled.img`
  cursor: pointer;
`



export const HeaderCell = styled.th`
  color: #696969;
  background-color: #f5f5f5;
  text-align: start;
  border: 0;
  font-size: 14px;
  padding-left: 2vw;
`

export const ItemCell = styled.td`
  width: 15vw;
  text-align: start;
  font-size: 14px;
  padding-left: 2vw;
  border-bottom: solid 1px #ebebeb;
  word-wrap: break-word;
  overflow-wrap: break-word;
`

export const ItemCellContainer = styled.div`
  display:flex;
  gap:0.3vw;
  align-items:center;

  .documentUrl {
    cursor:pointer;
    &:hover {
    color: #0090d3;
    }
  }
`


export const ImageCell = styled.td`
  background-color: #fff;
  width: 5vw;
  text-align: start;
  font-size: 14px;
  padding-left: 1vw;
  border-bottom: solid 1px #EBEBEB;
  word-wrap: break-word;
  overflow-wrap: break-word;
`


export const Input = styled.input`
    width: 9.5vw;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    margin-top: 0.8vh;
    margin-right: 1vh;
    padding-left: 1vw;
    padding-right: 1vw;
    font-size: 1.3vw;
    color: #696969;
    :focus {
        outline: 0;
    }
`

export const SwitchDiv = styled.div`
    display: flex;
    flex-direction: column;
`

export const SwitchBox = styled.label`
    display: inline-block;
    position: relative;
    width: 60px;
    height: 34px;
`

export const SwitchInput = styled.input`
    opacity: 0;
    width: 0;
    height: 0;

    :checked + .slider {
        background-color: #2196F3;
        border: 0;
        padding: 2px;
    }

    :focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    :checked + .slider:before {
        background-image: url(${check});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 15px 15px;
        background-color: #fff;
        -webkit-transform: translateX(24px);
        -ms-transform: translateX(24px);
        transform: translateX(24px);
    }
`

export const SwitchSlider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
    border: #696969 2px solid;

    :before {
        display: block;
        position: relative;
        content: "";
        height: 24px;
        width: 24px;
        left: 5.5px;
        top: 2.8px;
        background-color: #696969;
        border-radius: 50%;
        transition: all 0.4s;
        background-image: url(${cross});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 11px 11px;
    }
`